export default __webpack_public_path__ + "static/media/shareBG3.872f1a1a.png";